// src/components/layout/GuestLayout.tsx
import React from 'react';
import { Outlet } from 'react-router-dom';
import ResponsiveNav from '../navigation/ResponsiveNav';
import ShowrunnrLogo from '../ShowrunnrLogo';
import Footer from '../Footer';
import UserMenu from '../UserMenu'; // Import the UserMenu component
import { useAuth } from '../../contexts/AuthContext'; // Import your auth context

const GuestLayout: React.FC = () => {
  const { user, logout } = useAuth(); // Get user and logout function
  
  return (
    <div className="guest-layout">
      <ResponsiveNav 
        role="guest"   
        logo={<ShowrunnrLogo width={150} height={50} />}
        userEmail={user?.email || ''} // Add user email
        onLogout={logout} // Add logout function
        UserMenu={UserMenu} // Add UserMenu component
      />
      <main className="guest-main-content">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default GuestLayout;